module.exports = __webpack_public_path__ + "img/icon-arrow-left.7f1eb98a.svg";